import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getcorpFinanceCityStart,
  getcorpFinanceCitySuccess,
  getcorpFinanceCityFailure,
} from "../reducers/getcorpFinanceCityReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getcorpFinanceCity = createAsyncThunk(
  "getcorpFinanceCity",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getcorpFinanceCityStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Corporate_And_Financial/GetCity`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getcorpFinanceCitySuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getcorpFinanceCityFailure(error.response.data.Message));

      throw error;
    }
  }
);
